import { type MutationError, trpc } from '@/shared/api';

interface UseSetLandingHeroImageProductOptions {
  readonly onSuccess?: () => void;
}

/** 배너에 상품을 연결하거나(productId) 끊는다(null). 공개 상품만 연결된다 — 서버가 다시 확인한다. */
export const useSetLandingHeroImageProduct = ({
  onSuccess,
}: UseSetLandingHeroImageProductOptions = {}) => {
  const mutation = trpc.landing.setHeroImageProduct.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    setProduct: (id: string, productId: string | null) => mutation.mutate({ id, productId }),
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 관리 화면의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
